<template>
  <div>
    <template v-if="loading">
      <v-skeleton-loader
        class="mb-6"
        type="image"
      />
      <v-container class="py-4 mb-8">
        <v-skeleton-loader
          class="mb-6"
          type="heading"
        />
        <v-skeleton-loader
          type="text"
        />
        <v-skeleton-loader
          type="paragraph"
        />
      </v-container>
    </template>
    <template v-else>
      <v-img
        :src="require('@/assets/img-banner-news.jpg')"
        :contain="$store.state.mobile ? false : true"
        class="mx-auto"
        height="260"
      />
      <v-container class="py-4 mb-8">
        <div class="text-h2 my-3 font-medium line-after mb-6">
          <template v-if="$store.getters.languageGetter === '1'">
            أخبار
          </template>
          <template v-else>
            News
          </template>
        </div>
        <div class="text-h3">
          {{ $store.getters.languageGetter === '1' ? news.dnames : news.dnamesEn }}
        </div>
        <div class="grey--text">
          {{ news.createTime.substr(0,10) }}
        </div>
        <v-divider class="my-4" />
        <div
          v-if="news.content"
          class="img-fluid"
          v-html="$store.getters.languageGetter === '1' ? news.content : news.contentEn"
        />
        <div
          v-else
          class="text-center pt-4 grey--text"
        >
          <v-img
            :src="require('@/assets/nothing.png')"
            width="256"
            class="mx-auto mb-4"
          />
          <template v-if="$store.getters.languageGetter === '1'">
            لا شيء هنا.
          </template>
          <template v-else>
            Nothing here.
          </template>
        </div>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NewsDetail',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      news: {},
    };
  },
  computed: {
    ...mapGetters(['bannerNews']),
  },
  created() {
    this.loadPageData();
    this.getAdListAsync();
  },
  methods: {
    ...mapActions(['getAdListAsync']),
    ...mapActions(['getNewsDetailAsync']),
    loadPageData() {
      this.loading = true;
      this.getNewsDetailAsync({ id: this.id }).then((res) => {
        this.news = res;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
